<script>
export default {
  name: "Page",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backIcon(){
      return new URL("../../../assets/images/icons/arrow-left.svg", import.meta.url).href
    }
  }
}
</script>

<template>
<div class="wizard-page">
  <div class="page-header">
    <a-icon v-if="showBackButton" icon="24:arrow-left" height="24" width="24"  @click="$emit('back')" class="clickable"></a-icon>
    <div class="page-title" :class="{'text-center': showBackButton, 'text-left': !showBackButton}">
      <a-text as="h5">{{ title }}</a-text>
    </div>
    
  </div>
  <div class="my-3"></div>
  <slot></slot>
  <div class="my-3"></div>

</div>
</template>

<style scoped lang="scss">
.page-header {
  display: flex;
  width: 100%;
  .page-title {
    width: 100%;
  }
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
</style>
